module.exports = __webpack_public_path__ + "img/car_white.3a9339d0.png";